import { render } from "./Owner.vue?vue&type=template&id=aef45334&scoped=true"
import script from "./Owner.vue?vue&type=script&lang=js"
export * from "./Owner.vue?vue&type=script&lang=js"

import "./Owner.vue?vue&type=style&index=0&id=aef45334&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef45334"]])

export default __exports__